import styled from "styled-components";
import { Divider } from "antd";

export const Custom = styled(Divider)`
  //border-bottom: 1px solid gray;
  margin: 10px 0;
  border-top: 2px solid rgba(0, 0, 0, 0.3);
`;

export const ThreeElements = styled.div`
  color: gray;
  align-items: center;
  justify-content: space-between;
  /* padding: 20px; */
  /* height: 30px; */
  //border-bottom: 1px solid #fafafa;
  display: inline-flex;
  align-items: center;
  font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* text-indent: -20px; */
`;

export const Subscription = styled.div`
  margin-right: 5px;
  font-size: 120%;
`;

export const Invalid = styled.div`
  align-items: center;
  justify-content: space-between;
  /* padding: 20px; */
  /* height: 30px; */
  border-bottom: 1px solid #fafafa;
  display: inline-flex;
  align-items: center;
  font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

export const Cancelled = styled.div`
  color: gray;
  flex: 1;
  font-style: italic;
  font-size: 10px;
  text-align: left;
  bottom: 0;
  //text-indent: -50px;
`;

export const ClassPrice = styled.div`
  /* direction: rtl; */
  font-weight: 600;
  font-size: 120%;
`;

export const Total = styled.div`
  width: 100%;
  min-height: 10px;
  display: flex;
  flex-direction: row;
  border-radius: 2px;
  margin: 0px 0px 8px;
  background-color: white;
`;
